import React from "react";
import { useParams } from "react-router-dom";
import sportgruppenData from "../../data/sportgruppenData";
import Carousel from 'react-bootstrap/Carousel';
import "./SportgruppePage.css";

const SportgruppePage = () => {
  const { id } = useParams();
  const gruppe = sportgruppenData.find((item) => item.id === id);

  if (!gruppe) {
    return <h2 className="not-found">Sportgruppe nicht gefunden!</h2>;
  }

  return (
    <div className="sportgruppe-container">
      {/* Hauptbereich */}
      <div className="sportgruppe-content">
        {/* Text links */}
        <div className="sportgruppe-text">
          <h1 className="sportgruppe-title">{gruppe.title}</h1>
          <p className="sportgruppe-description">{gruppe.description}</p>

          <h2 className="info-title">Zeitplan</h2>
          <ul className="schedule-list">
            {gruppe.schedule.map((item, index) => (
              <li key={index} className="schedule-item">
                🕒 {item}
              </li>
            ))}
          </ul>

          <h2 className="info-title">Details</h2>
          <p className="sportgruppe-details">{gruppe.details}</p>
        </div>

        {/* Bild rechts */}
        <div className="sportgruppe-image-wrapper">
          <img src={gruppe.image} alt={gruppe.title} className="sportgruppe-image" />
        </div>
      </div>

      {/* Galerie mit React Carousel */}
      <div className="sportgruppe-gallery">
        <h2 className="info-title">Galerie</h2>
        <Carousel interval={3000} className="gallery-carousel">
          {gruppe.gallery.map((img, index) => (
            <Carousel.Item key={index}>
              <img src={img} alt={`Galerie ${index}`} className="carousel-image" />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      {/* Call-to-Action */}
      <div className="sportgruppe-footer">
        <a href="/contact" className="btn-primary">Jetzt teilnehmen</a>
      </div>
    </div>
  );
};

export default SportgruppePage;
